module.exports = __webpack_public_path__ + "img/tls_certificate.7204234e.png";